import { Tag } from '__models__/gql/tag';

const tagDummy: Tag = {
  id: '1',
  name: 'QA Engineering',
};

export default tagDummy;
